export default __webpack_public_path__ + "static/media/evo-title-en.39b5c6c2.webp";